import { render, staticRenderFns } from "./RegistroNotificacao.vue?vue&type=template&id=2ede451c&"
import script from "./RegistroNotificacao.vue?vue&type=script&lang=js&"
export * from "./RegistroNotificacao.vue?vue&type=script&lang=js&"
import style0 from "./RegistroNotificacao.vue?vue&type=style&index=0&id=2ede451c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports